import React from "react";
import { Select, Button } from "antd";
import { SortAscendingOutlined, SortDescendingOutlined } from "@ant-design/icons";

const { Option } = Select;

const SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "createdAt", label: "Date Added" },
  { value: "fileSize", label: "File Size" },
];

const SortControl = ({ sortOption, sortDirection, onSortChange, onDirectionChange }) => {
  return (
    <div className="creative-library__sort-control">
      <Select
        value={sortOption}
        onChange={onSortChange}
        size="small"
        suffixIcon={null}
      >
        {SORT_OPTIONS.map((opt) => (
          <Option key={opt.value} value={opt.value}>
            {opt.label}
          </Option>
        ))}
      </Select>
      <Button
        size="small"
        icon={sortDirection === "asc" ? <SortAscendingOutlined /> : <SortDescendingOutlined />}
        onClick={() => onDirectionChange(sortDirection === "asc" ? "desc" : "asc")}
      />
    </div>
  );
};

export default SortControl;
